import zh from 'iview/dist/locale/zh-CN'
export default {
  zh: Object.assign({
    add: '新增',
    search: '搜索',
    edit: '编辑',
    save: '保存',
    confrim: '确定',
    cancel: '取消',
    close: '关闭',
    delete: '删除',
    check: '查看',
    return: '返回',
    prev: '上一步',
    next: '下一步',
    downtpl: '下载模板',
    open: '展开',
    packup: '收起',
    append: '添加',
    browse: '浏览',
    reset: '清空'
  }, zh)
}


// WEBPACK FOOTER //
// ./src/plugins/i18n/zh.js